import { createApi } from '@reduxjs/toolkit/dist/query/react';
import {
  type TGetSelfResponse,
  type TTraderDashboardPreferences,
  type TTraderDashboardResponse,
} from '../types/TraderTypes';
import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';

export const TraderApi = createApi({
  reducerPath: 'TraderApi',
  tagTypes: ['Trader'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    getSelf: build.query<TGetSelfResponse, void>({
      query: () => ({
        url: '/users/get_self/',
        method: 'GET',
      }),
      providesTags: [{ type: 'Trader', id: 'LIST' }],
      transformErrorResponse: (response: any) => {
        if (response.status === 401) {
          window.location.href = '/';
          localStorage.removeItem('token');
        }
      },
      transformResponse: (response: TGetSelfResponse) => {
        if (!response.active || !response) {
          window.location.href = '/';
          localStorage.removeItem('token');
        }
        return response;
      },
    }),
    getDashboard: build.query<TTraderDashboardResponse, void>({
      query: () => ({
        url: '/users/dashboard/',
        method: 'GET',
      }),
      providesTags: [{ type: 'Trader', id: 'DASHBOARD' }],
    }),
    updateDashboardPreferences: build.mutation<
      TTraderDashboardPreferences,
      Partial<TTraderDashboardPreferences>
    >({
      query: (body) => ({
        url: '/users/dashboard_preferences/',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'Trader', id: 'DASHBOARD' }],
    }),
  }),
});

export const {
  useGetSelfQuery,
  useGetDashboardQuery,
  useUpdateDashboardPreferencesMutation,
} = TraderApi;
